<template>
  <div class="award">
    <div class="contentBox" v-if="isShowInfo">
      <div class="title">《{{ ruleForm.AwardName }}》评选材料提交页</div>
      <el-form :model="ruleForm" ref="ruleForm" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="企业工商名称"
              prop="SCC">
            <el-input
                v-model="ruleForm.CompanyNameCN"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="联系人手机"
              prop="PhoneNumber">
              <el-input
                v-model="ruleForm.PhoneNumber"
                disabled
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="remark">
              <strong>您已申报的奖项：</strong><br/>
              {{ (ruleForm.ApplyAwardTypeNames).join('，') }}
            </div>
            
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="AwardAttachments" label="上传附件" :rules="[
                { required: true, message: '请上传申报奖项附件', trigger: 'blur' },
              ]">
              <div class="fileFlex">
                <UploadPan
                  ref="upload2"
                  v-model="fileList2"
                  :form="form"
                  class="editor-upload-btn"
                  :model="model"
                  @on-close="handleCloseUpload2"
                  @on-update="handleOnUpdate2"
                  :accept="accept2"
                  color="#1890ff"
                />
                <span class="spanRemark"
                  >上传文件数量提示：如文件数量较多可压缩后上传，并以【企业名称+申报奖项命名】，请勿上传视频文件。每个上传文件大小不超过1G。</span
                >
              </div>
              <ul v-show="ruleForm.AwardAttachments" class="listFile">
                <li
                  v-for="(fileItem, index) in ruleForm.AwardAttachments"
                  :key="index"
                >
                  <div class="div1">{{ fileItem.name }}</div>
                  <div class="div2" @click="removeItem(fileItem.url)">
                    删除
                  </div>
                </li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="btnClass">
              <el-button @click="clickSubmit('ruleForm')" type="primary" :disabled="ruleForm.Status !== 1"
                >提交</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </div>
    <div class="noPage" v-else>找不到页面</div>
    <el-dialog title="资料提交提示" 
      :visible.sync="dialogVisible" 
      width="50%" center      
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div class="sussDiv">
        <div class="sussOne">
          <img src="../../assets//successs.svg" alt=""> 资料提交成功
        </div>
        <div class="sussTwo">您已报名成功，进入资料审核阶段。</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAwardApplicationInfoByID,
  getAwardAttachments,
} from '../../api/api'
import UploadPan from '@/components/Upload/index'
export default {
  data() {
    return {
      UploadApi: `${process.env.VUE_APP_BASE_API}/api/AwardApplication/upload`,
      isShowInfo: false, // 是否显示页面
      ruleForm: {
        AwardName: '', // 标题名称
        Status: 0,
        CompanyNameCN: '',
        PhoneNumber: '',
        ApplyAwardTypeNames: [],
        EncryptId:'',
        AwardAttachments:[]
      },
      disabled: false, // 是否禁用  即点击之后一段时间内无法再点击

      dataForm:[],
      active: 1,
      dialogVisible: false, // 提交后的提示
      fileList2: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept2: '*',
    }
  },
  components: {
    UploadPan,
  },
  methods: {
    // 提交
    clickSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.EncryptId= this.$route.params.id
          getAwardAttachments(this.ruleForm).then((res) => {
            if (res.data.success) {
              // this.$router.push('/success')
              this.dialogVisible = true
              
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning',
              })
            }
          })
        } else {
          return false
        }
      })
    },

    handleCloseUpload2() {
      this.fileList2 = []
    },
    handleOnUpdate2(obj) {
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      let attachment = {
        url: url,
        name: obj.ResTitle,
        ContentType: obj.ContentType,
        Type: 2,
      }
      this.ruleForm.AwardAttachments.push(attachment)
    },
    // 删除附件
    removeItem(url) {
      this.ruleForm.AwardAttachments = this.ruleForm.AwardAttachments.filter(
        (item) => item.url != url
      )
      this.$forceUpdate()
    },

    // 关闭弹窗
    handleClose(){
      this.dialogVisible = false
      this.getAwardApplicationInfoByID()
    },

    // 根据ID查找奖项名称
    getAwardApplicationInfoByID(){
      getAwardApplicationInfoByID(this.$route.params.id).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response
          this.isShowInfo = true
          this.ruleForm.EncryptId = '',
          this.ruleForm.AwardAttachments = []
          if(res.data.response.Status !== 1) {
            this.$message({
              type: 'warning',
              message: '当前页面不可操作，请勿继续操作！，',
            })
          }
        } else {
          this.isShowInfo = false
        }
      })
    },
    
    // 添加判断方法
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      console.log(flag)
      return flag;
    }
  },
  mounted() {
    this.getAwardApplicationInfoByID()

    if(this.isMobile()){
      this.$message({
        message: '请复制链接，在电脑端进行操作！',
        type: 'warning',
        duration:10000
      })
    }  
  },
}
</script>

<style scoped>
.award {
  width: 100%;
  height: 100vh;
  position: relative;
  background: rgba(200, 200, 200, 0.1);
  overflow: auto;
}
.contentBox {
  position: relative;
  border: 0px solid red;
  width: 1000px;
  display: block;
  margin: 0 auto;
  padding: 30px 30px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(65, 67, 70, 0.1);
}
.title {
  text-align: center;
  font-size: 24px;
  line-height: 36px;
  font-weight: bold;
  padding: 0 0;
  margin: 0 0 50px;
}
.remark, .remark strong {
  font-size: 15px;
  line-height: 26px;
  color: #606266;
}
.remark {
  padding-left: 130px;
  margin-bottom: 15px
}
.fileFlex {
  display: flex;
  align-items: center;
}
.divLogos a {
  margin-right: 20px;
}
.btnClass {
  text-align: center;
  color: #606266;
}
.spanRemark {
  color: #606266;
  margin-left: 20px;
}

.noPage {
  text-align: center;
  font-size: 30px;
  line-height: 40px;
  padding: 100px;
}
.sussDiv{
  text-align: center;
}
.sussDiv img{
  width: 36px;
  display:block;
  margin-right: 20px;
}
.sussOne{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  line-height: 30px
}
.sussTwo{
  margin-top: 30px;
  font-size: 16px;
  line-height: 30px;
}
.listFile {
  color: #555555;
  margin: 20px 0 0;
  padding: 0 0;
}
.listFile li {
  list-style-type: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 0 10px;
}
.listFile li:hover{
  background-color: #F5F7FA;
}
.listFile .div1 {
  flex: 1;
}
.listFile .div2 {
  width: 30px;
  cursor: pointer;
}
</style>
